import { ChatIcon } from '../../components/ChatIcon';
import { ListItem } from '../../components/ListItem';
import { DriverNameFormat } from '../../components/DriverNameFormat';
import type { Chat } from '../../services/chatAdministrationApi';
import Tag from '@rio-cloud/rio-uikit/Tag';

type RecipientListItemProps = {
    recipient: Chat;
    onClick: () => void;
};

export const RecipientListItem = (props: RecipientListItemProps) => {
    const { recipient, onClick } = props;

    return (
        <ListItem className='RecipientListItem' onClick={onClick}>
            <ChatIcon type={recipient.type} />
            <div className='flex-1-1 text-medium'>
                {recipient.lastName ? (
                    <DriverNameFormat firstName={recipient.firstName} lastName={recipient.lastName} />
                ) : (
                    <>
                        {recipient.name}
                        {recipient.type === 'asset' && recipient.licensePlate && (
                            <Tag size='small' round={false} className='padding-x-3 padding-y-2 margin-left-5 scale-90'>
                                {recipient.licensePlate}
                            </Tag>
                        )}
                    </>
                )}
            </div>
        </ListItem>
    );
};
